import { fetchApiWithError } from '@upright/ui/api/common/fetchers/fetch-with-error';
import { getFromApi, postToApi, deleteFromApi } from '@upright/ui/api/common/fetchers/request-api';
import { ImpactLabelDatum, ImpactLabelProductType } from '../../../../../common/model/input/impacts/types';

export async function fetchAllImpactLabels(version: string) {
  return fetchApiWithError<ImpactLabelDatum[]>(`/impact-labels/${version}`);
}

/**
 * Fetch all impact labels that fall within given impact category
 */
export async function fetchAllImpactLabelsForImpactCode(version: string, impactCode: string) {
  const data = await getFromApi<ImpactLabelDatum[]>(`/impact-labels/${version}`);
  if (!data) {
    return;
  }
  // if we wish to improve performance at some point we can do this filtering
  // server side but this will do fine for now
  return data.filter(d => d.impactCode === impactCode);
}

export async function addImpactLabelPhrase(impactId: string, phrase: string) {
  return postToApi<ImpactLabelDatum>(`/impact-label/${impactId}/phrase/${encodeURIComponent(phrase)}`);
}

export async function deleteImpactLabelPhrase(impactId: string, phrase: string) {
  return deleteFromApi<ImpactLabelDatum>(`/impact-label/${impactId}/phrase/${encodeURIComponent(phrase)}`);
}

export async function addImpactLabelProductWhitelisting(
  impactId: string,
  productCode: string,
  type: ImpactLabelProductType,
) {
  return postToApi<ImpactLabelDatum>(`/impact-label/${impactId}/product/${productCode}/type/${type}`);
}

export async function deleteImpactLabelProductWhitelisting(
  impactId: string,
  productCode: string,
  type: ImpactLabelProductType,
) {
  return deleteFromApi<ImpactLabelDatum>(`/impact-label/${impactId}/product/${productCode}/type/${type}`);
}
